const errors: {[key:string]: { error_code:string; default_message:string; default_title:string; image:string; }} = {
  "404": {
    "error_code": "404",
    "default_message": "hubo un error inesperado",
    "default_title": "lo sentimos",
    "image": "https://bedu-staging-assets.s3.us-west-2.amazonaws.com/ULA/ULA_404_b42676fbbb.png"
  }
} 
 export default errors